import * as React from "react";
import { Clock } from "react-feather";
import { Alert, Modal } from "antd";
import humanizeDuration from "humanize-duration";
import { CopyButtonWithApproval } from "../domain/create/copyButtonWithApproval";

export interface InstallLocationData {
  command: string;
  manifestLink: string;
  expires: number;
}

interface Props {
  installLocationData: InstallLocationData;
  onCancel: () => void;
}

export const InstallLocation: React.FC<Props> = ({ installLocationData, onCancel }) => {
  const [timeLeft, setTimeLeft] = React.useState<number>(installLocationData.expires - Math.floor(Date.now() / 1000));
  const [isExpired, setIsExpired] = React.useState<boolean>(false);

  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = Math.floor(Date.now() / 1000);
      const timeDifference = installLocationData.expires - currentTime;
      if (timeDifference <= 0) {
        setIsExpired(true);
        clearInterval(interval);
      }
      setTimeLeft(timeDifference);
    }, 1000);

    return () => clearInterval(interval);
  }, [installLocationData.expires]);

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          Install Location
          <Alert
            type="error"
            icon={<Clock size={16} />}
            description={
              <span>{isExpired ? "Expired" : `Expires In: ${humanizeDuration(timeLeft * 1000, { round: true })}`}</span>
            }
          />
        </div>
      }
      open={true}
      maskClosable={false}
      onCancel={onCancel}
      onOk={onCancel}
    >
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1">
          <span className="list-decimal">Apply below command in kubectl</span>
          <div className="flex items-center">
            {/* TODO can have a generic component for this */}
            <input
              className="flex-grow border px-2 py-1"
              style={{
                width: 450,
              }}
              disabled={true}
              value={installLocationData.command}
            />
            <CopyButtonWithApproval className="ml-1" value={installLocationData.command} />
          </div>
        </div>
        <Alert
          type="warning"
          description={
            <span>Manifest link in the command contains sensitive information and is only available temporarily.</span>
          }
        />
      </div>
    </Modal>
  );
};
